import {NgClass, NgIf} from '@angular/common';
import {AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild} from '@angular/core';
import {NbIconModule} from '@nebular/theme';

@Component({
  standalone: true,
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  imports: [
    NgClass,
    NgIf,
    NbIconModule
  ],
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements AfterViewInit {
  constructor(
    private renderer: Renderer2,
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (e.target !== this.dropdownLabel?.nativeElement) {
        if (this.inputElement) {
          this.closeDropdownList();
        }
      }
    });
  }

  inputElement: HTMLInputElement = null;
  labelElement: HTMLLabelElement = null;
  // allElements: HTMLCollectionOf<Element> = null;

  @Input() name: string = '';
  @Input() showIcon: boolean = true;
  @Input() index: string | number = null;
  @Input() placeholder: string = 'Не указан placeholder';
  @Input() direction: 'bottom' | 'top' | 'left' = 'bottom';

  @ViewChild('dropdownLabel') dropdownLabel: ElementRef;

  ngAfterViewInit(): void {
    this.labelElement = document.getElementById(
      'label_' + this.name + this.index,
    ) as HTMLLabelElement;

    // this.allElements = this.labelElement.getElementsByTagName('*');
  }

  fieldClick(name: string, id: string | number) {
    console.log('click');
    this.inputElement = document.getElementById(
      'input_' + name + id,
    ) as HTMLInputElement;

    this.toggleDropdownList();
  }

  public toggleDropdownList() {
    console.log('click');
    const inputElement = document.getElementById(
      'input_' + this.name + this.index,
    ) as HTMLInputElement;
    inputElement.checked = !inputElement?.checked;
  }

  public openDropdownList() {
    const inputElement = document.getElementById(
      'input_' + this.name + this.index,
    ) as HTMLInputElement;
    inputElement.checked = true;
  }

  public closeDropdownList() {
    const inputElement = document.getElementById(
      'input_' + this.name + this.index,
    ) as HTMLInputElement;
    inputElement.checked = false;
  }
}
